import { SnackToast as Toast } from "@/utils/snackToast";
import { NUP, applyMask } from "@/utils/protocols";
import { downloadWithURL } from "@/utils/fileUtility";

import router from "@/router";
import { General } from "@/utils/constants";
import {
  createProcess,
  getProcessAutoDraft,
  setProcessAutoDraft,
  setProcessDraft,
  deleteProcessDraft,
  getProcess,
  getProcessList,
  getProcessListByCapacity,
  getMyProcessList,
  getArchivesProcess,
  setArchivesProcess,
  getArchivesJustificationList,
  getSignatureHistory,
  readSignatureRequest,
  setUserResponsible,
  getCheckResponsible,
  getDispatchAutoDraft,
  setDispatchAutoProcessing,
  setProcessAutoProcessing,
  getFavoriteProcess,
  setFavoriteProcess,
  getProcessProcessed,
  editProcessDraft,
  getJoint,
  getProcessDraftList,
  getProcessSearch,
  getProcessAppended,
  getMigration,
  getMigrationsList,
  checkAccessProcess,
  requestProcessTabsCount,
  setDispatchAutoDraft,
  createDispatch,
  setModifiedProcess,
  setModifiedBookmarkProcess,
  getSearchByFilter,
  getSearchFields,
  setJoint,
  createJoint,
  deleteJoint,
  hasAutoDraftWrittenRequest,
  setProcessAppended,
  setProcessUnappended,
  validateReturnProcessRequest,
  returnProcess,
  returnProcessOrigin,
  migrateProcess,
  cancelMigrateProcess,
  setKnowledgeProcess,
  reportRequest,
  forwardProcess,
  createPendencyRequest,
  requestPendingList,
  cancelPendency,
  getPendencyDocumentTypes,
  getProcessFileSize,
  deleteDispatchDraft,
  simpleMyProcessList,
  getSimpleNUP,
  checkProcessDocumentJoint,
  reindexProcess,
  getSearchViproc,
  getCanGiveKnowledge,
  getProcessView,
  downloadProcess,
  getDownloadProcessStatus,
  getGroupItemProcess,
  getCheckDraftProcessed,
  getProcessSize,
  getCheckDraftDelete,
  hasResponsible
} from "@/services/api/process/ApiProcess";
import { readNotificationRequest } from "@/services/api/process/ApiSignature";

import {
  FilterPaged,
  IGiveKnowledge,
  ResponseGenericType,
  ResponsePaged,
  ResponseType
} from "@/store/types/types";
import { ActionContext } from "vuex/types";

import {
  IProcess,
  ISubmitProcess,
  IArchivedProcess,
  IProcessId,
  IProcessFavorite,
  IProcessResponsible,
  IMigration,
  IProcessMigration,
  IListMigration,
  IArchiveJustification,
  IProcessData,
  IProcessAction,
  IProcessDownload,
  IProcessDownloadEndpoint,
  IDispatch,
  IProcessSearchSuggests,
  IProcessAppend,
  IProcessTabCount,
  IReportRequest,
  IProcessMigrate,
  IProcessForward,
  IProcessPendency,
  IFilterSearch,
  IProcessDraft,
  IProcessInbox,
  IProcessSize,
  IProcessProcessed,
  IProcessArchived,
  IProcessUser,
  ICurrentProcess,
  IProcessReference,
  IProcessSimple,
  IProcessSimpleResponse,
  IUserDocumentJoin,
  IVPROC,
  IProcessGroupRequest
} from "@/store/types/process-type";
import { IGiveKnowledgeRequest } from "@/store/types/user-types";

import {
  IDocumentJoin,
  IDocumentModel,
  IProcessReturn
} from "@/store/types/document-type";
import { showSuccessMessage, showErrorMessage } from "@/utils/messageUtility";
import { ICapacityPublic } from "@/store/types/control-types";
import { RootState } from "@/store/types/root";
import {
  PRIORITY,
  PROCESS_DOWNLOAD_STATUS_BACK as DOWNLOAD_STATUS_BACK,
  CONFIDENTIAL_SECRECY_IDS as CONFIDENTIAL_IDS,
  PROCESS_DOWNLOAD_STATUS as DOWNLOAD_STATUS,
  PROCESS_DETAILS_TABS as PROCESS_DETAILS
} from "@/utils/enumerate";
import { SnackQueue as Queue } from "@/plugins/SnackQueue";
import { IBookmark } from "../types/bookmark-types";

const state = {
  newProcess: { user_notification: {} } as IProcess,
  process: null,
  currentProcess: {} as ICurrentProcess,
  referenceProcess: null as IProcess | null,
  appendedProcesses: [] as IProcessData[],
  processList: [] as IProcess[],
  processListCount: 0,
  processCapacityList: [] as IProcessData[],
  processCapacityListCount: 0,
  draftList: [] as IProcessData[],
  draftListCount: 0,
  archiveList: [] as IProcess[],
  archiveListCount: 0,
  dispatch: {} as IDispatch,
  joint: {} as IDocumentJoin,
  favoriteList: [] as IProcessData[],
  favoriteListCount: 0,
  myProcessList: [] as IProcessData[],
  myProcessListCount: 0,
  processedList: [] as IProcessData[],
  processedListCount: 0,
  searchedProcessList: [] as IProcess[],
  processSubmitList: [] as ISubmitProcess[],
  searchedProcessListCount: 0,
  migrationsList: [] as IListMigration[],
  migrationsListCount: 0,
  suggests: [] as string[],
  errorMessage: "",
  updateBySockets: "",
  processActions: [] as IProcessAction[],
  processDownload: [] as IProcessDownload[],
  listReferenceProcess: [] as IProcessReference[],
  processMigration: [] as IProcessMigration[],
  migrationList: [],
  justificationList: [] as string[][],
  filterList: { search: "" },
  clearProcess: 0,
  clearDispatch: 0,
  pendingList: [] as IProcessPendency[],
  pendingDocumentTypeList: [] as IDocumentModel[],
  processFileSize: 0 as number,
  simpleMyProcessList: [] as IProcessSimple[],
  simpleProcess: null as IProcessSimpleResponse | null,
  dispatchNeedsUpdate: 0,
  processVPROC: {} as IVPROC,
  isSearchSuite: true
};

type State = typeof state;

const mutations = {
  setProcessActions: (state: State, list: IProcessAction[]) => {
    state.processActions = list;
  },

  updateProcessActionsWebSocket: (state: State, item: IProcessAction) => {
    state.processActions.push(item);
  },

  setCurrentProcess: (state: State, process: ICurrentProcess) => {
    state.currentProcess = process;
  },

  updateCurrentProcess: (state: State, data: ICurrentProcess) => {
    state.currentProcess = { ...state.currentProcess, ...data };
  },

  setReferenceProcess: (state: State, process: IProcess) => {
    state.referenceProcess = process;
  },

  setProcessSubmitList: (state: State, processList: ISubmitProcess[]) => {
    state.processSubmitList = processList;
  },

  addProcessSubmitList: (state: State, processList: ISubmitProcess[]) => {
    processList.forEach(process => state.processSubmitList.push(process));
  },

  updateProcessSubmit: (state: State, process: ISubmitProcess) => {
    const indexProcess = state.processSubmitList.findIndex(
      actualProcess => actualProcess.process_index === process.process_index
    );
    if (indexProcess === -1) return;
    state.processSubmitList[indexProcess] = process;
    state.processSubmitList = [...state.processSubmitList];
  },

  clearListSubmitProcess: (state: State) => {
    state.processSubmitList = [];
  },

  setListReferenceProcess: (state: State, process: IProcessReference[]) => {
    state.listReferenceProcess = process;
  },

  setAppendedProcesses: (state: State, data: IProcessData[]) => {
    state.appendedProcesses = data;
  },

  setNewProcess: (state: State, process: IProcess) => {
    state.newProcess = process;
  },

  updateProcessBookmark: (state: State, data: IBookmark[]) => {
    state.newProcess.bookmark = data;
  },

  showJoinMenssage: (_: State, data: { nup: string; process_id: string }) => {
    Toast.open({
      message: `${General.MESSAGES.WARNING_JOIN_DOCUMENT.replace(
        "(NUP)",
        applyMask(NUP, data.nup)
      )}!`,
      detail: {
        link: `/app/processos/detalhamento/${data.process_id}`,
        message: `${General.GO_TO_DOCUMENT}.`
      },
      type: "is-warning",
      position: "is-top",
      duration: 8000,
      queue: false
    });
  },

  processListSuccess: (state: State, data: ResponsePaged<IProcess>) => {
    state.processList = data.results;
    state.processListCount = data.count;
  },

  processCapacityListSuccess: (
    state: State,
    data: ResponsePaged<IProcessData>
  ) => {
    state.processCapacityList = data.results;
    state.processCapacityListCount = data.count;
  },

  draftListSuccess: (state: State, data: ResponsePaged<IProcessData>) => {
    state.draftList = data.results;
    state.draftListCount = data.count;
  },

  processArchiveList: (state: State, data: ResponsePaged<IProcess>) => {
    state.archiveList = data.results;
    state.archiveListCount = data.count;
  },

  favoriteListSuccess: (state: State, data: ResponsePaged<IProcessData>) => {
    state.favoriteList = data.results;
    state.favoriteListCount = data.count;
  },

  processedListSuccess: (state: State, data: ResponsePaged<IProcessData>) => {
    state.processedList = data.results;
    state.processedListCount = data.count;
  },

  myProcessListSuccess: (state: State, data: ResponsePaged<IProcessData>) => {
    state.myProcessList = data.results;
    state.myProcessListCount = data.count;
  },

  // dispatch mutations
  // getDraft
  dispatchDraftSuccess: (state: State, dispatch: IDispatch) => {
    state.dispatch = dispatch;
  },

  setSearchedProcess: (state: State, data: ResponsePaged<IProcess>) => {
    if (data) {
      state.searchedProcessList = data.results.map(process => ({
        ...process,
        cc: process.cc_object?.object,
        due_date: process.due_date_object?.object
      })) as IProcess[];
      state.searchedProcessListCount = data.count;
    } else {
      state.searchedProcessList = [];
      state.searchedProcessListCount = 0;
    }
  },

  setProcessVPROC: (state: State, data: IVPROC) => {
    state.processVPROC = data;
  },

  setClearDispatch: (state: State) => {
    state.clearDispatch = Date.now();
  },

  setClearProcess: (state: State) => {
    state.clearProcess = Date.now();
  },

  setSuggests: (state: State, data: IProcessSearchSuggests) => {
    state.suggests = data.suggests;
  },

  setJoint: (state: State, data: IDocumentJoin) => {
    state.joint = data;
  },

  clearUpdateBySockets: (state: State) => {
    state.updateBySockets = "";
  },

  setUpdateBySockets: (state: State, data: { type: string }) => {
    state.updateBySockets = data.type;
  },

  setListMigrate: (state: State, data: IProcessMigration[]) => {
    state.processMigration = data;
  },

  setMigrationsList: (state: State, data: ResponsePaged<IListMigration>) => {
    state.migrationsList = data.results;
    state.migrationsListCount = data.count;
  },

  resetMigrate: (state: State) => {
    state.processMigration = [];
  },

  setProcessJustificationList: (state: State, data: IArchiveJustification) => {
    state.justificationList = data.options;
  },

  setFilterList: (state: State, data: IFilterSearch) => {
    state.filterList = { ...data };
  },

  setPendingList: (state: State, data: IProcessPendency[]) => {
    state.pendingList = data;
  },

  setPendencyDocumentTypeList: (state: State, data: IDocumentModel[]) => {
    state.pendingDocumentTypeList = data;
  },

  setProcessFileSize: (state: State, data: number) => {
    state.processFileSize = data;
  },

  addProcessFileSize: (state: State, data: number) => {
    state.processFileSize += data;
  },

  setSimpleMyProcessList: (
    state: State,
    data: ResponsePaged<IProcessSimple>
  ) => {
    state.simpleMyProcessList = data.results;
  },

  resetSimpleMyProcessList: (state: State) => {
    state.simpleMyProcessList = [];
  },

  setSimpleProcess: (state: State, data: IProcessSimpleResponse) => {
    state.simpleProcess = data;
  },

  setNewDispatchUpdate: (state: State) => {
    state.dispatchNeedsUpdate = Date.now();
  },

  setSearchSuite: (state: State, data: boolean) => {
    state.isSearchSuite = data;
  },

  pushProcessDownload: (state: State, data: IProcessDownload) => {
    state.processDownload.push(data);
  },

  removeProcessDownload: (state: State, processId: string) => {
    const index = state.processDownload.findIndex(
      process => process.processId === processId
    );
    state.processDownload.splice(index, 1);
  },

  updateProcessDownloadState: (
    state: State,
    { process_id, status, download_url = "" }: IProcessDownloadEndpoint
  ) => {
    const newStatus = DOWNLOAD_STATUS_BACK[
      status
    ] as IProcessDownload["status"];
    const index = state.processDownload.findIndex(
      process => process.processId === process_id
    );
    if (!newStatus || index < 0) return;
    state.processDownload[index].status = newStatus;
    state.processDownload[index].download_url = download_url;
  }
};

const actions = {
  processAutoDraftRequest: async ({
    commit
  }: ActionContext<State, RootState>) => {
    const results: ResponseType<IProcess> = await getProcessAutoDraft();

    if (results.kind === "ok") commit("setNewProcess", results.data);
    else showErrorMessage(results.message);
  },

  processSaveAutoDraftRequest: async (
    _: ActionContext<State, RootState>,
    process: IProcess
  ) => {
    const results: ResponseType<IProcess> = await setProcessAutoDraft(process);

    if (results.kind !== "ok") showErrorMessage(results.message);
    return results.data;
  },

  processSubmitDraftRequest: async (
    _: ActionContext<State, RootState>,
    process: IProcess
  ) => {
    const results: ResponseGenericType = await setProcessDraft(process);

    if (results.kind === "ok")
      showSuccessMessage({ message: General.TEXTS.DRAFT_SAVE });
    else showErrorMessage(results.message);

    return results.kind === "ok";
  },

  processSubmitRequest: async (
    { commit }: ActionContext<State, RootState>,
    process: IProcess
  ) => {
    if (process.type != "reference") process.reference_number = null;

    const results: ResponseType<IProcess> = await createProcess(process);

    if (results.kind === "ok" && results.data) {
      const urlPath = `/app/processos/detalhamento/${results.data.id}`;

      const redirect = () => {
        commit("setCurrentTabProcessDetails", PROCESS_DETAILS.BASIC_DATA.value);

        router.push(urlPath);
      };

      const componentProps = {
        message: General.MESSAGES.PROCESSED_PROCESS_CONFIRM,
        replaceText: results.data.nup,
        redirect
      };

      showSuccessMessage({ componentName: "ToastWithLink", componentProps });
      return results.data;
    } else showErrorMessage(results.message);
    return false;
  },

  requestProcess: async (
    { commit }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<ICurrentProcess> = await getProcess(processId);

    if (results.kind === "Not Found")
      results.message = General.PROCESS_NOT_FOUND;

    if (results.kind === "ok" && results.data)
      commit("setCurrentProcess", {
        ...results.data
      });
    else showErrorMessage(results.message);

    return results;
  },

  searchProcessByNup: async (
    { commit }: ActionContext<State, RootState>,
    nup: string
  ) => {
    const results: ResponseType<IProcessReference[]> = await getProcessSearch(
      nup
    );
    if (results.kind === "Not Found")
      results.message = `O processo ${nup} não existe!`;

    if (results.kind === "ok") commit("setListReferenceProcess", results.data);
    else showErrorMessage(results.message);
  },

  requestMigration: async (
    { commit }: ActionContext<State, RootState>,
    migrateId: string | number
  ) => {
    const results: ResponseType<IMigration> = await getMigration(migrateId);

    if (results.kind === "ok" && results.data) {
      commit(
        "setListMigrate",
        results.data.processes.map(process => ({
          ...process,
          migration_id: migrateId
        }))
      );
      if (results.data?.report_file)
        downloadWithURL(results.data.report_file, "Relatorio_migracao", "pdf");
    } else showErrorMessage(results.message);
  },

  requestMigrationsList: async (
    { commit }: ActionContext<State, RootState>,
    { paginator_count, page, search, date, order_by }: FilterPaged
  ) => {
    const results: ResponseType<ResponsePaged<
      IListMigration
    >> = await getMigrationsList({
      paginator_count,
      page,
      search,
      date,
      order_by
    });

    if (results.kind !== "ok") showErrorMessage(results.message);
    else commit("setMigrationsList", results.data);
    return results;
  },

  processListRequest: async (
    { commit }: ActionContext<State, RootState>,
    { page, order_by, paginator_count, search }: FilterPaged
  ) => {
    const results: ResponseType<ResponsePaged<IProcess>> = await getProcessList(
      {
        page,
        order_by,
        paginator_count,
        search
      }
    );

    if (results.kind === "ok") commit("processListSuccess", results.data);
    else showErrorMessage(results.message);
  },

  processArchiveRequest: async (
    { commit, getters }: ActionContext<State, RootState>,
    {
      page,
      order_by,
      capacity,
      paginator_count,
      search,
      filters,
      ignore_order_by_default,
      with_children = false,
      only_count = undefined
    }: FilterPaged
  ) => {
    const results: ResponseType<ResponsePaged<
      IProcessArchived
    >> = await getArchivesProcess({
      page,
      order_by,
      capacity,
      paginator_count,
      search,
      filters,
      ignore_order_by_default,
      with_children,
      only_count
    });

    if (results.kind === "ok" && results.data) {
      const resultsData = !only_count
        ? results.data.results?.map(process => ({
            ...process,
            capacity: getters.getCapacityById(process.capacity),
            origin: getters.getCapacityById(process.origin)
          }))
        : [];
      commit("processArchiveList", {
        ...results.data,
        results: resultsData
      });
    } else showErrorMessage(results.message);
  },

  processArchiveUpdate: async (
    _: ActionContext<State, RootState>,
    { list, msg_success }: { list: IArchivedProcess; msg_success: string }
  ) => {
    const results: ResponseGenericType = await setArchivesProcess(list);

    if (results.kind !== "ok") showErrorMessage(results.message);
    else showSuccessMessage({ message: msg_success });
  },

  archivesJustificationListRequest: async ({
    commit
  }: ActionContext<State, RootState>) => {
    const results: ResponseType<IArchiveJustification> = await getArchivesJustificationList();

    if (results.kind !== "ok") showErrorMessage(results.message);
    else commit("setProcessJustificationList", results.data);
  },

  getSignatureHistoryRequest: async (
    { commit }: ActionContext<State, RootState>,
    listProcessId: string[]
  ) => {
    if (listProcessId.length) {
      const results: ResponseType<IProcessAction[]> = await getSignatureHistory(
        listProcessId
      );

      if (results.kind === "ok") {
        commit("setProcessActions", results.data);
      } else showErrorMessage(results.message);
    }
  },

  readSignature: async (
    _: ActionContext<State, RootState>,
    process_id: string
  ) => {
    const results: ResponseGenericType = await readSignatureRequest(process_id);

    if (results.kind !== "ok") showErrorMessage(results.message);
  },

  readNotificationRequest: async (
    _: ActionContext<State, RootState>,
    process_id: string
  ) => {
    const results: ResponseGenericType = await readNotificationRequest(
      process_id
    );

    if (results.kind !== "ok") showErrorMessage(results.message);
  },

  processCapacityListRequest: async (
    { commit, getters }: ActionContext<State, RootState>,
    {
      capacityId,
      page,
      order_by,
      paginator_count,
      search,
      filters,
      ignore_order_by_default,
      with_children = false,
      only_count = undefined
    }: FilterPaged
  ) => {
    if (!capacityId) return;
    const results: ResponseType<ResponsePaged<
      IProcessInbox
    >> = await getProcessListByCapacity({
      capacityId,
      page,
      order_by,
      paginator_count,
      search,
      filters,
      ignore_order_by_default,
      with_children,
      only_count
    });

    if (results.kind === "ok" && results.data) {
      const resultsData = !only_count
        ? results.data.results?.map(process => ({
            ...process,
            origin: getters.getCapacityById(process.origin)
          }))
        : [];
      commit("processCapacityListSuccess", {
        ...results.data,
        results: resultsData
      });
    } else showErrorMessage(results.message);
  },

  draftListRequest: async (
    { commit, getters }: ActionContext<State, RootState>,
    {
      page,
      order_by,
      paginator_count,
      search,
      filters,
      ignore_order_by_default,
      only_count = undefined
    }: FilterPaged
  ) => {
    const results: ResponseType<ResponsePaged<
      IProcessDraft
    >> = await getProcessDraftList({
      page,
      order_by,
      paginator_count,
      search,
      filters,
      ignore_order_by_default,
      only_count
    });

    if (results.kind === "ok" && results.data) {
      const resultsData = !only_count
        ? results.data.results.map(process => ({
            ...process,
            draft_to: process.draft_to?.map(getters.getCapacityById)
          }))
        : [];
      commit("draftListSuccess", {
        ...results.data,
        results: resultsData
      });
    } else showErrorMessage(results.message);
  },

  favoriteListRequest: async (
    { commit, getters }: ActionContext<State, RootState>,
    {
      page,
      order_by,
      capacity,
      paginator_count,
      search,
      filters,
      ignore_order_by_default,
      only_count = undefined
    }: FilterPaged
  ) => {
    const results: ResponseType<ResponsePaged<
      IProcessFavorite
    >> = await getFavoriteProcess({
      page,
      order_by,
      capacity,
      paginator_count,
      search,
      filters,
      ignore_order_by_default,
      only_count
    });

    if (results.kind === "ok" && results.data) {
      const resultsData = !only_count
        ? results.data.results?.map(process => ({
            ...process,
            capacity: getters.getCapacityById(process.capacity)
          }))
        : [];
      commit("favoriteListSuccess", {
        ...results.data,
        results: resultsData
      });
    } else showErrorMessage(results.message);
  },

  setFavoriteProcess: async (
    _: ActionContext<State, RootState>,
    processIdList: IProcessFavorite[]
  ) => {
    const results: ResponseGenericType = await setFavoriteProcess(
      processIdList
    );

    if (results.kind !== "ok") showErrorMessage(results.message);
    return results.kind === "ok";
  },

  processedListRequest: async (
    { commit, getters }: ActionContext<State, RootState>,
    {
      page,
      order_by,
      capacity,
      paginator_count,
      search,
      filters,
      ignore_order_by_default,
      with_children = false,
      only_count = undefined
    }: FilterPaged
  ) => {
    const results: ResponseType<ResponsePaged<
      IProcessProcessed
    >> = await getProcessProcessed({
      page,
      order_by,
      capacity,
      paginator_count,
      search,
      filters,
      ignore_order_by_default,
      with_children,
      only_count
    });

    if (results.kind === "ok" && results.data) {
      const resultsData = !only_count
        ? results.data.results?.map(process => ({
            ...process,
            capacity: getters.getCapacityById(process.capacity)
          }))
        : [];
      commit("processedListSuccess", {
        ...results.data,
        results: resultsData
      });
    } else showErrorMessage(results.message);
  },

  // Dispatch Actions
  dispatchGetDraft: async (
    { commit }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<IDispatch> = await getDispatchAutoDraft(
      processId
    );

    if (results.kind === "ok") commit("dispatchDraftSuccess", results.data);
    else showErrorMessage(results.message);
  },

  dispatchPutAutoDraft: async (
    _: ActionContext<State, RootState>,
    dispatch: IDispatch
  ) => {
    const results: ResponseType<IDispatch> = await setDispatchAutoDraft(
      dispatch
    );

    if (results.kind !== "ok") showErrorMessage(results.message);
    return results.data;
  },

  dispatchProcess: async (
    _: ActionContext<State, RootState>,
    dispatch: IDispatch
  ) => {
    const results: ResponseGenericType = await createDispatch(dispatch),
      status = results.kind === "ok";

    if (status)
      showSuccessMessage({ message: General.MESSAGES.DISPATCH_PROCESS });
    else showErrorMessage(results.message);

    return status;
  },

  setDispatchAutoProcessing: async (
    { state }: ActionContext<State, RootState>,
    { dispatchId, automatic }: { dispatchId: string; automatic: boolean }
  ) => {
    const results: ResponseGenericType = await setDispatchAutoProcessing(
      dispatchId,
      automatic
    );

    if (results.kind === "ok") {
      showSuccessMessage({
        message: results.data?.message || General.MESSAGES.DISPATCH_PROCESS
      });
      state.dispatch.automatic_processing = automatic;
    } else showErrorMessage(results.message);
    return results.data;
  },

  setProcessAutoProcessing: async (
    { state }: ActionContext<State, RootState>,
    { processId, automatic }: { processId: string; automatic: boolean }
  ) => {
    const results: ResponseGenericType = await setProcessAutoProcessing(
      processId,
      automatic
    );

    if (results.kind === "ok") {
      showSuccessMessage({
        message: results.data?.message || General.MESSAGES.TRAMITED_PROCESS
      });
      state.newProcess.automatic_processing = automatic;
    } else showErrorMessage(results.message);
    return results.data;
  },

  deleteProcessDraft: async (
    _: ActionContext<State, RootState>,
    processIdList: IProcessId[]
  ) => {
    const results: ResponseGenericType = await deleteProcessDraft(
      processIdList
    );

    if (results.kind === "ok")
      showSuccessMessage({
        message: General.MESSAGES.DRAFT_SUCCESSFULLY_DELETED
      });
    else showErrorMessage(results.message);
  },

  deleteDispatchDraftRequest: async (
    _: ActionContext<State, RootState>,
    dispatchId: string
  ) => {
    const results: ResponseGenericType = await deleteDispatchDraft(dispatchId);

    if (results.kind === "ok")
      showSuccessMessage({
        message: General.MESSAGES.DRAFT_SUCCESSFULLY_DELETED
      });
    else showErrorMessage(results.message);
  },

  editProcessDraft: async (
    _: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseGenericType = await editProcessDraft(processId);

    if (results.kind === "ok") router.push(`/app/novo-processo`);
    else showErrorMessage(results.message);
  },

  modifiedProcess: async (
    { commit }: ActionContext<State, RootState>,
    { data, process_id }: { data: IProcess; process_id: string }
  ) => {
    const results: ResponseGenericType = await setModifiedProcess({
      data,
      processId: process_id
    });

    if (results.kind === "ok") commit("updateCurrentProcess", data);
    else showErrorMessage(results.message);
    return results.kind === "ok";
  },

  modifiedBookmarkProcess: async (
    { commit }: ActionContext<State, RootState>,
    { data, process_id }: { data: IProcess; process_id: string }
  ) => {
    const results: ResponseGenericType = await setModifiedBookmarkProcess({
      data,
      processId: process_id
    });

    if (results.kind === "ok") commit("updateCurrentProcess", data);
    else showErrorMessage(results.message);
    return results.kind === "ok";
  },

  myProcessListRequest: async (
    { commit, getters }: ActionContext<State, RootState>,
    {
      page,
      order_by,
      paginator_count,
      search,
      filters,
      ignore_order_by_default,
      only_count = undefined
    }: FilterPaged
  ) => {
    const results: ResponseType<ResponsePaged<
      IProcessUser
    >> = await getMyProcessList({
      page,
      order_by,
      paginator_count,
      search,
      filters,
      ignore_order_by_default,
      only_count
    });

    if (results.kind === "ok" && results.data) {
      const resultsData = !only_count
        ? results.data.results?.map(process => ({
            ...process,
            capacity: getters.getCapacityById(process.capacity),
            origin: getters.getCapacityById(process.origin)
          }))
        : [];
      commit("myProcessListSuccess", {
        ...results.data,
        results: resultsData
      });
    } else showErrorMessage(results.message);
  },

  userResponsibleRequest: async (
    _: ActionContext<State, RootState>,
    {
      userResponsible,
      responsibleName
    }: { userResponsible: IProcessResponsible; responsibleName: string }
  ) => {
    const results: ResponseGenericType = await setUserResponsible(
      userResponsible
    );

    if (results.kind !== "ok") showErrorMessage(results.message);
    else {
      showSuccessMessage({
        message: General.TEXTS.PROCESS_ASSIGN_RESPONSIBLE.replace(
          "(NAME_AND_ORGAN)",
          responsibleName
        )
      });
    }
  },

  checkUserPermissionResponsible: async (
    _: ActionContext<State, RootState>,
    processList: string[]
  ) => {
    const results: ResponseGenericType = await getCheckResponsible(processList);

    if (results.kind === "ok") return results;
    showErrorMessage(results.message);
  },

  checkProcessHistoryInternal: (
    { getters }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const isValidProcessHistory = () => {
      const historySearch = getters.getSearchedProcessList.list.find(
        ({ id }: IProcess) => id === processId
      )?.history_search;
      const history = getters.getTimeLineItens;
      if (!historySearch?.length || !history?.length) return true;
      if (historySearch.length !== history.length) return false;
      if (historySearch.at(-1)?.status !== history[0].status) return false;
      return true;
    };

    if (!isValidProcessHistory()) {
      reindexProcess(processId);
    }
  },

  checkProcessHistory: (
    { getters }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const isValidProcessHistory = () => {
      const historySearch = getters.getSearchedProcessList.list.find(
        ({ id }: IProcess) => id === processId
      )?.history_search;
      const history = getters.getTimeLineItens;
      if (!historySearch || historySearch.length !== history.length)
        return false;

      for (const idxHistory in historySearch) {
        if (historySearch[idxHistory].status !== history[idxHistory].status)
          return false;
        if (
          history[idxHistory].date.includes(
            historySearch[idxHistory].date.slice(0, -1)
          )
        )
          return false;
      }

      return true;
    };

    if (!isValidProcessHistory()) {
      reindexProcess(processId);
    }
  },

  searchProcessByFilter: async (
    { commit }: ActionContext<State, RootState>,
    { filters, page, order_by, paginator_count }: FilterPaged
  ) => {
    const results: ResponseType<ResponsePaged<
      IProcess
    >> = await getSearchByFilter({ filters, page, order_by, paginator_count });
    if (results.kind === "ok") commit("setSearchedProcess", results.data);
    else showErrorMessage(results.message);
  },

  searchViprocProcess: async (
    { commit }: ActionContext<State, RootState>,
    search: string
  ) => {
    const results: ResponseType<IVPROC> = await getSearchViproc(
      search.replace(/\D/g, "")
    );
    const status = results.kind === "ok";
    if (status) {
      commit("setProcessVPROC", results.data);
      if (router.currentRoute.path !== "/consultar-viproc")
        router.push(`/consultar-viproc`);
    } else showErrorMessage(results.message);
  },

  getFieldsForSearch: async (
    { commit }: ActionContext<State, RootState>,
    { filter, field = null }: { filter: string; field: string | null }
  ) => {
    const results: ResponseType<IProcessSearchSuggests> = await getSearchFields(
      { search_text: filter, field }
    );

    if (results.kind === "ok") commit("setSuggests", results.data);
    else showErrorMessage(results.message);
  },

  getProcessJoint: async (
    { commit }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<IDocumentJoin> = await getJoint(processId);

    if (results.kind === "ok") commit("setJoint", results.data);
    else showErrorMessage(results.message);
  },

  setProcessJoint: async ({
    commit,
    state
  }: ActionContext<State, RootState>) => {
    const results: ResponseType<IDocumentJoin> = await setJoint(state.joint);

    if (results.kind === "ok") commit("setJoint", results.data);
    else showErrorMessage(results.message);
  },

  createProcessJoint: async ({
    commit,
    state
  }: ActionContext<State, RootState>) => {
    const results: ResponseGenericType = await createJoint(state.joint);

    if (results.kind === "ok") {
      commit("setJoint", {});
      showSuccessMessage({
        message: General.TEXTS.ATTACH_JOINT
      });
    } else showErrorMessage(results.message);
  },

  deleteProcessJoint: async ({
    commit,
    state
  }: ActionContext<State, RootState>) => {
    const results: ResponseGenericType = await deleteJoint(state.joint.id);

    if (results.kind === "ok") commit("setJoint", {});
    else showErrorMessage(results.message);
  },

  setProcessAppend: async (
    _: ActionContext<State, RootState>,
    {
      processId,
      processAppend
    }: { processId: string; processAppend: IProcessAppend }
  ) => {
    const results: ResponseGenericType = await setProcessAppended({
      processId,
      processAppend
    });

    if (results.kind !== "ok") showErrorMessage(results.message);

    return results.kind === "ok";
  },

  requestProcessTabsCount: async (
    { commit }: ActionContext<State, RootState>,
    capacities: number[]
  ) => {
    const results: ResponseType<IProcessTabCount> = await requestProcessTabsCount(
      capacities
    );

    if (results.kind !== "ok") commit("documentSignError", results.message);
    return results.data;
  },

  validateReturnProcessRequest: async (
    _: ActionContext<State, RootState>,
    listProcessReturn: string[]
  ) => {
    const results: ResponseGenericType = await validateReturnProcessRequest(
      listProcessReturn
    );

    if (results.kind !== "ok") showErrorMessage(results.message);

    return results.kind === "ok";
  },

  returnProcessRequest: async (
    _: ActionContext<State, RootState>,
    listProcessReturn: IProcessReturn[]
  ) => {
    const results: ResponseGenericType = await returnProcess(listProcessReturn);

    if (results.kind !== "ok") showErrorMessage(results.message);

    return results.kind === "ok";
  },

  returnProcessOriginRequest: async (
    _: ActionContext<State, RootState>,
    listProcessReturn: IProcessReturn[]
  ) => {
    const results: ResponseGenericType = await returnProcessOrigin(
      listProcessReturn
    );

    if (results.kind !== "ok") showErrorMessage(results.message);

    return results.kind === "ok";
  },

  getProcessAppended: async (
    { commit, getters }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<IProcessData[]> = await getProcessAppended(
      processId
    );

    if (results.kind === "ok")
      commit(
        "setAppendedProcesses",
        results.data?.map(process => ({
          ...process,
          origin: getters.getCapacityById(process.origin)
        }))
      );
    else showErrorMessage(results.message);
  },

  hasAutoDraftWritten: async (
    _: ActionContext<State, RootState>,
    { processId, capacityId }: { processId: string; capacityId: number }
  ) => {
    const results: ResponseGenericType = await hasAutoDraftWrittenRequest({
      processId,
      capacityId
    });

    if (results.kind !== "ok") showErrorMessage(results.message);
    return results.data;
  },

  reportRequest: async (
    { dispatch }: ActionContext<State, RootState>,
    reportConfig: IReportRequest
  ) => {
    const results: ResponseGenericType = await reportRequest(reportConfig);

    if (results.kind === "ok") dispatch("startDownload", results.data);
    else {
      showErrorMessage(results.message);
      dispatch("startDownload", { file_index: reportConfig.file_index });
    }
    return results.data;
  },

  setProcessUnappended: async (
    _: ActionContext<State, RootState>,
    {
      processId,
      processDetachJoin
    }: { processId: string; processDetachJoin: IProcessAppend }
  ) => {
    const results: ResponseGenericType = await setProcessUnappended(
      processId,
      processDetachJoin
    );

    const status = results.kind === "ok";
    if (!status) showErrorMessage(results.message);
    return status;
  },

  updateMigration: async (
    { state, dispatch, commit }: ActionContext<State, RootState>,
    processMigrate: IProcessMigration | IProcessMigration[]
  ) => {
    if (Array.isArray(processMigrate)) {
      commit("setListMigrate", processMigrate);
      return;
    }
    if (
      state.processMigration.length &&
      processMigrate.migration_id === state.processMigration[0].migration_id
    ) {
      const process = state.processMigration.find(
        process => process.nup === processMigrate.nup
      );
      if (process) process.status = processMigrate.status;
    } else await dispatch("requestMigration", processMigrate.migration_id);
  },

  migrateProcess: async (
    _: ActionContext<State, RootState>,
    migrate: IProcessMigrate
  ) => {
    const results: ResponseGenericType = await migrateProcess(migrate);

    if (results.kind !== "ok") showErrorMessage(results.message);
    return results;
  },

  cancelMigrateProcess: async (
    _: ActionContext<State, RootState>,
    migrationId: string
  ) => {
    const results: ResponseGenericType = await cancelMigrateProcess(
      migrationId
    );

    if (results.kind !== "ok") showErrorMessage(results.message);
    return results;
  },

  postGiveKnowledgeProcess: async (
    _: ActionContext<State, RootState>,
    { process_id, user, LGPD, observation, is_external }: IGiveKnowledgeRequest
  ) => {
    const results = await setKnowledgeProcess({
      process_id,
      user,
      LGPD,
      observation,
      is_external
    });
    return { list: results.data, state: results.kind === "ok" };
  },

  checkAccessProcessRequest: async (
    _: ActionContext<State, RootState>,
    { processId, flow }: { processId: string; flow: string }
  ) => {
    const results: ResponseGenericType = await checkAccessProcess(
      processId,
      flow
    );

    if (results.kind !== "ok") showErrorMessage(results.message);
    return results.kind === "ok";
  },

  forwardProcess: async (
    _: ActionContext<State, RootState>,
    forwardProcessList: IProcessForward
  ) => {
    const results: ResponseGenericType = await forwardProcess(
      forwardProcessList
    );

    if (results.kind !== "ok") showErrorMessage(results.message);
    return results.kind === "ok";
  },

  createPendencyRequest: async (
    _: ActionContext<State, RootState>,
    {
      process_id,
      origin,
      capacity_id,
      pendency_documents,
      observation = ""
    }: IProcessPendency
  ) => {
    const results: ResponseGenericType = await createPendencyRequest({
      process_id,
      origin,
      capacity_id,
      pendency_documents,
      observation
    });

    if (results.kind !== "ok") showErrorMessage(results.message);
    return results.kind === "ok";
  },

  requestPendingList: async (
    { commit }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<IProcessPendency[]> = await requestPendingList(
      processId
    );

    if (results.kind !== "ok") showErrorMessage(results.message);
    else commit("setPendingList", results.data);

    return results.kind === "ok";
  },

  cancelPendency: async (
    _: ActionContext<State, RootState>,
    pendencyId: string
  ) => {
    const results: ResponseGenericType = await cancelPendency(pendencyId);

    if (results.kind !== "ok") showErrorMessage(results.message);
    return results.kind === "ok";
  },

  requestPendencyDocumentTypes: async (
    { commit }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<IDocumentModel[]> = await getPendencyDocumentTypes(
      processId
    );

    if (results.kind !== "ok") showErrorMessage(results.message);
    else commit("setPendencyDocumentTypeList", results.data);

    return results.kind === "ok";
  },

  requestProcessFileSize: async (
    { commit }: ActionContext<State, RootState>,
    {
      processId,
      exclude_draft = true
    }: { processId: string; exclude_draft: boolean }
  ) => {
    const results: ResponseType<IProcessSize> = await getProcessFileSize({
      processId,
      exclude_draft
    });

    if (results.kind !== "ok") showErrorMessage(results.message);
    else commit("setProcessFileSize", results.data?.total_size);

    return results.kind === "ok";
  },

  simpleMyProcessListRequest: async (
    { commit }: ActionContext<State, RootState>,
    { page, order_by, paginator_count, search }: FilterPaged
  ) => {
    const results: ResponseType<ResponsePaged<
      IProcessSimple
    >> = await simpleMyProcessList({
      page,
      order_by,
      paginator_count,
      search
    });

    if (results.kind === "ok" && results.data) {
      commit("setSimpleMyProcessList", results.data);
    } else showErrorMessage(results.message);
  },

  requestProcessByNupSimple: async (
    { commit }: ActionContext<State, RootState>,
    nup: string
  ) => {
    const results: ResponseType<IProcessSimple> = await getSimpleNUP(nup);
    if (results.kind === "Not Found")
      results.message = `O processo ${nup} não existe!`;

    if (results.kind === "ok") commit("setSimpleProcess", results.data);
    else showErrorMessage(results.message);
  },

  requestCheckProcessDocumentJoint: async (
    _: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<IUserDocumentJoin[]> = await checkProcessDocumentJoint(
      processId
    );

    if (results.kind !== "ok") showErrorMessage(results.message);

    return results.data;
  },

  getCanGiveKnowledgeRequest: async (
    _: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<IGiveKnowledge> = await getCanGiveKnowledge(
      processId
    );
    if (results.kind === "ok" && results.data)
      return results.data.can_give_knowledge;
    else showErrorMessage(results.message);
    return false;
  },

  checkAndAddProcessDownlaod: (
    { commit, getters }: ActionContext<State, RootState>,
    newProcess: IProcessDownload
  ) => {
    const exists = getters.getProcessDownloadState(newProcess.processId);
    if (!exists) {
      commit("pushProcessDownload", newProcess);
    }
    return !exists;
  },

  getDetailProcessViewer: async (
    _: ActionContext<State, RootState>,
    params: { processId: string; giveKnowledgeId?: string }
  ) => {
    const results: ResponseType<{ process: string }> = await getProcessView(
      params
    );

    if (results.kind === "ok" && results.data) return results.data;
    else showErrorMessage(results.message);
  },

  downloadProcessFile: async (
    { commit }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<{
      download_url?: string;
      status: string;
      message?: string;
    }> = await downloadProcess(processId);

    if (
      results.data?.download_url ||
      results.data?.status === DOWNLOAD_STATUS["FAILED"]
    ) {
      Queue.open({
        id: `download_process:${processId}`,
        canClose: true
      });
    }

    if (results.kind !== "ok") {
      const url = results.data?.download_url;
      if (url) {
        const componentProps = {
          message: results.message,
          replaceText:
            General.MESSAGES.ALERT_CLICK_HERE_LATEST_VERSION_DOCUMENT,
          redirect: () => {
            window.open(url, "_blank", "noopener");
          }
        };

        showErrorMessage(
          undefined,
          true,
          "is-warning",
          8000,
          "ToastWithLink",
          componentProps
        );
      } else {
        const message =
          results.data?.message ??
          "Ocorreu um erro inesperado, tente novamente.";
        showErrorMessage(message);
      }
      Queue.close(`download_process:${processId}`);
      commit("updateProcessDownloadState", {
        process_id: processId,
        status: DOWNLOAD_STATUS_BACK.ERROR
      });
      commit("removeProcessDownload", processId);
      return false;
    }
    commit("updateProcessDownloadState", {
      ...results.data,
      process_id: processId
    });
    return results.data;
  },

  getProcessBuildState: async (
    { commit }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<IProcessDownload> = await getDownloadProcessStatus(
      processId
    );

    if (results.kind === "ok" && results.data)
      commit("updateProcessDownloadState", {
        ...results.data,
        process_id: processId
      });
    else showErrorMessage(results.message);
    return results.kind === "ok";
  },

  getGroupItens: async (
    _: ActionContext<State, RootState>,
    groupRequest: IProcessGroupRequest
  ) => {
    const results: ResponseType<IProcessDownload> = await getGroupItemProcess(
      groupRequest
    );

    if (results.kind === "ok" && results.data) return results.data;
    else showErrorMessage(results.message);
  },

  getProcessSizeAction: async (
    _: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<IProcessDownload> = await getProcessSize(
      processId
    );

    if (results.kind === "ok" && results.data) return results.data;
    else showErrorMessage(results.message);
  },

  submitProcess: async (
    { commit, dispatch }: ActionContext<State, RootState>,
    process: ISubmitProcess
  ) => {
    commit("updateProcessSubmit", { ...process, status: "in progress" });
    const result = await dispatch("processSubmitRequest", process.processBody);
    const status = result ? "finished" : "error";
    commit("updateProcessSubmit", { ...process, ...result, status });
    dispatch("processSubmitTrigger");
  },

  processSubmitTrigger: ({
    dispatch,
    state
  }: ActionContext<State, RootState>) => {
    const hasSubmitInProgress = state.processSubmitList.some(
      (process: ISubmitProcess) => process.status === "in progress"
    );

    if (!hasSubmitInProgress) {
      const processSubmitPending = state.processSubmitList.find(
        process => process.status === "pending"
      );
      processSubmitPending && dispatch("submitProcess", processSubmitPending);
    }
  },

  checkDraftProcessSubmit: async (
    { commit, state, dispatch }: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseType<{
      nup: string;
      capacity_id: number;
    }[]> = await getCheckDraftProcessed(processId);

    if (results.kind === "ok" && results.data?.length) {
      const actualState: any = [];
      results.data.forEach(actual => {
        actualState[actual.capacity_id] = actual.nup;
      });

      const newListSubmit = state.processSubmitList.map(process => {
        const capacityId = process.processBody?.draft_to?.id;
        const existProcess = actualState[capacityId];
        if (existProcess) {
          process.nup = existProcess;
          process.status = "finished";
        }
        return process;
      });
      commit("setProcessSubmitList", newListSubmit);
    }
    dispatch("processSubmitTrigger");
  },

  clearListSubmitProcess: async ({
    commit,
    state
  }: ActionContext<State, RootState>) => {
    const processId = state.processSubmitList?.[0]?.processBody?.id;
    if (processId) {
      await getCheckDraftDelete(processId);
      commit("clearListSubmitProcess");
    }
  },

  setCancelProcessSubmit: ({
    commit,
    state
  }: ActionContext<State, RootState>) => {
    const newListSubmit = state.processSubmitList.map(process => ({
      ...process,
      status: process.status === "pending" ? "canceled" : process.status
    }));
    commit("setProcessSubmitList", newListSubmit);
  },

  hasResponsible: async (
    _: ActionContext<State, RootState>,
    processId: string
  ) => {
    const results: ResponseGenericType = await hasResponsible(processId);
    if (results.kind === "ok") {
      return results.data;
    }
    showErrorMessage(results.message);
  }
};

interface Getters {
  getCapacityById: (_id: number) => ICapacityPublic;
}

const getters = {
  getProcess: (state: State) => state.process,

  getNewProcess: (state: State) => state.newProcess || {},

  getCurrentProcess: (state: State, getters: Getters) => {
    const subject_name =
      typeof state.currentProcess.subject === "object" &&
      state.currentProcess.subject.name;
    return {
      subject_name,
      ...state.currentProcess,
      capacity: {
        ...getters.getCapacityById(state.currentProcess.capacity_id)
      },
      origin: { ...getters.getCapacityById(state.currentProcess.origin) }
    };
  },

  getReferenceProcess: (state: State) => state.referenceProcess,

  getAppendedProcesses: (state: State) => state.appendedProcesses,

  getDispatch: (state: State) => state.dispatch,

  getProcessListByUser: (state: State) => ({
    list: state.myProcessList,
    count: state.myProcessListCount
  }),

  getProcessListByCapacity: (state: State) => ({
    list: state.processCapacityList,
    count: state.processCapacityListCount
  }),

  getDraftList: (state: State) => ({
    list: state.draftList,
    count: state.draftListCount
  }),

  getArchiveList: (state: State) => ({
    list: state.archiveList,
    count: state.archiveListCount
  }),

  getFavoriteList: (state: State) => ({
    list: state.favoriteList,
    count: state.favoriteListCount
  }),

  getProcessedList: (state: State) => ({
    list: state.processedList,
    count: state.processedListCount
  }),

  getSuggests: (state: State) => state.suggests,

  getSearchedProcessList: (state: State) => ({
    list: state.searchedProcessList,
    count: state.searchedProcessListCount
  }),

  getCurrentJoint: (state: State) => state.joint,

  getUpdateBySockets: (state: State) => state.updateBySockets,

  getSignatureRequests: (state: State) => state.processActions,

  getListProcess: (state: State) =>
    state.listReferenceProcess.map(item => ({
      ...item,
      nup_mask: applyMask(NUP, item.nup)
    })),

  getProcessMigrationList: (state: State) => state.processMigration,

  getMigrationsList: (state: State) => ({
    list: state.migrationsList,
    count: state.migrationsListCount
  }),

  getJustificationList: (state: State) => state.justificationList,

  getFilterList: (state: State) => state.filterList,

  getClearProcess: (state: State) => state.clearProcess,

  getClearDispatch: (state: State) => state.clearDispatch,

  getPendingList: (state: State) => state.pendingList,

  getPendingDocumentTypeList: (state: State) => state.pendingDocumentTypeList,

  getProcessFileSize: (state: State) => state.processFileSize,

  getSimpleMyProcessList: (state: State) => state.simpleMyProcessList,

  getProcessSimple: (state: State, getters: Getters) => {
    if (state.simpleProcess)
      return {
        ...state.simpleProcess,
        origin: getters.getCapacityById(state.simpleProcess?.origin),
        cc: state.simpleProcess.cc.map(item => {
          const capacity = getters.getCapacityById(item.capacity_id);
          if (!capacity) return item;
          return {
            ...item,
            abbreviation: capacity.abbreviation,
            description: capacity.description,
            entity: capacity.entity
          };
        })
      };
    else return state.simpleProcess;
  },

  getPriorityById: () => (id: number) => {
    return PRIORITY.find(option => option.id === id);
  },

  getDispatchUpdater: (state: State) => state.dispatchNeedsUpdate,

  getProcessVPROC: (state: State) => state.processVPROC,

  getIsSearchSuite: (state: State) => state.isSearchSuite,

  getProcessDownloadState: (state: State) => (uid: string) =>
    state.processDownload.find(process => process.processId === uid),

  getListSubmitProcess: (state: State) => state.processSubmitList,

  isConfidentialCheck: () => (secrecyId: number) => {
    return CONFIDENTIAL_IDS.includes(secrecyId);
  }
};

export default { state, mutations, actions, getters };
